var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPublic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_public_24px",
    fill: "currentColor",
    d: "M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M7.2,14.3C4,13.9,1.6,11.2,1.6,8     c0-0.5,0.1-1,0.2-1.4l3.8,3.8v0.8c0,0.9,0.7,1.6,1.6,1.6l0,0V14.3z M12.7,12.3c-0.2-0.7-0.8-1.1-1.5-1.1h-0.8V8.8     C10.4,8.4,10,8,9.6,8l0,0H4.8V6.4h1.6c0.4,0,0.8-0.4,0.8-0.8c0,0,0,0,0,0V4h1.6c0.9,0,1.6-0.7,1.6-1.6l0,0V2.1     c3.3,1.3,4.9,5,3.5,8.3C13.7,11.1,13.2,11.7,12.7,12.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPublic);
export default __webpack_public_path__ + "static/media/icon-public.83262656ef0a0492fe2eeb487dd75a44.svg";
export { ForwardRef as ReactComponent };